/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Misc_Androidbeta_Steps_Download1Inputs */

const id_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah ditambahkan, Anda dapat mengunduh aplikasi dari tautan yang disediakan`)
};

const ms_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Setelah ditambah, anda boleh memuat turun aplikasi dari pautan yang disediakan`)
};

const da_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Når du er tilføjet, kan du downloade appen fra det angivne link`)
};

const de_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nach dem Hinzufügen können Sie die App über den bereitgestellten Link herunterladen`)
};

const en_us2_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Once added, you can download the app from the provided link`)
};

const es_es2_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez añadido, podrás descargar la app desde el enlace proporcionado`)
};

const es_mx2_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una vez agregado, podrás descargar la app desde el enlace proporcionado`)
};

const fil_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kapag naidagdag, maaari mong i-download ang app mula sa ibinigay na link`)
};

const fr_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une fois ajouté, vous pourrez télécharger l'application depuis le lien fourni`)
};

const it_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una volta aggiunto, puoi scaricare l'app dal link fornito`)
};

const hu_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ha hozzáadtak, letöltheted az alkalmazást a megadott linkről`)
};

const nl_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zodra je bent toegevoegd, kun je de app downloaden via de verstrekte link`)
};

const no_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Når du er lagt til, kan du laste ned appen fra den oppgitte lenken`)
};

const pl_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po dodaniu będziesz mógł pobrać aplikację z podanego linku`)
};

const pt_br2_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Depois de adicionado, você pode baixar o aplicativo no link fornecido`)
};

const pt_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Após ser adicionado, pode descarregar a app a partir do link fornecido`)
};

const ro_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Odată adăugat, poți descărca aplicația de la linkul furnizat`)
};

const fi_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kun sinut on lisätty, voit ladata sovelluksen annetusta linkistä`)
};

const sv_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`När du har lagts till kan du ladda ner appen från den angivna länken`)
};

const vi_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sau khi được thêm, bạn có thể tải ứng dụng từ liên kết được cung cấp`)
};

const tr_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eklendikten sonra, sağlanan bağlantıdan uygulamayı indirebilirsiniz`)
};

const cs_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Po přidání si můžete stáhnout aplikaci z poskytnutého odkazu`)
};

const bg_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`След като бъдете добавени, можете да изтеглите приложението от предоставената връзка`)
};

const ru_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`После добавления вы сможете скачать приложение по предоставленной ссылке`)
};

const uk_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Після додавання ви зможете завантажити застосунок за наданим посиланням`)
};

const ar_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`بمجرد الإضافة، يمكنك تنزيل التطبيق من الرابط المقدم`)
};

const hi_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`लिंक से ऐप डाउनलोड करें`)
};

const th_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เมื่อเพิ่มแล้ว คุณจะสามารถดาวน์โหลดแอปจากลิงก์ที่ให้ไว้`)
};

const ja_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`追加されると、提供されたリンクからアプリをダウンロードできます`)
};

const zh_cn2_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加成功后，您可以通过提供的链接下载应用`)
};

const zh_hant1_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新增成功後，您可以透過提供的連結下載應用`)
};

const ko_misc_androidbeta_steps_download1 = /** @type {(inputs: Misc_Androidbeta_Steps_Download1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`추가되면 제공된 링크에서 앱을 다운로드할 수 있습니다`)
};

/**
* | output |
* | --- |
* | "Once added, you can download the app from the provided link" |
*
* @param {Misc_Androidbeta_Steps_Download1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const misc_androidbeta_steps_download1 = /** @type {((inputs?: Misc_Androidbeta_Steps_Download1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Misc_Androidbeta_Steps_Download1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_misc_androidbeta_steps_download1(inputs)
	if (locale === "ms") return ms_misc_androidbeta_steps_download1(inputs)
	if (locale === "da") return da_misc_androidbeta_steps_download1(inputs)
	if (locale === "de") return de_misc_androidbeta_steps_download1(inputs)
	if (locale === "en-US") return en_us2_misc_androidbeta_steps_download1(inputs)
	if (locale === "es-ES") return es_es2_misc_androidbeta_steps_download1(inputs)
	if (locale === "es-MX") return es_mx2_misc_androidbeta_steps_download1(inputs)
	if (locale === "fil") return fil_misc_androidbeta_steps_download1(inputs)
	if (locale === "fr") return fr_misc_androidbeta_steps_download1(inputs)
	if (locale === "it") return it_misc_androidbeta_steps_download1(inputs)
	if (locale === "hu") return hu_misc_androidbeta_steps_download1(inputs)
	if (locale === "nl") return nl_misc_androidbeta_steps_download1(inputs)
	if (locale === "no") return no_misc_androidbeta_steps_download1(inputs)
	if (locale === "pl") return pl_misc_androidbeta_steps_download1(inputs)
	if (locale === "pt-BR") return pt_br2_misc_androidbeta_steps_download1(inputs)
	if (locale === "pt") return pt_misc_androidbeta_steps_download1(inputs)
	if (locale === "ro") return ro_misc_androidbeta_steps_download1(inputs)
	if (locale === "fi") return fi_misc_androidbeta_steps_download1(inputs)
	if (locale === "sv") return sv_misc_androidbeta_steps_download1(inputs)
	if (locale === "vi") return vi_misc_androidbeta_steps_download1(inputs)
	if (locale === "tr") return tr_misc_androidbeta_steps_download1(inputs)
	if (locale === "cs") return cs_misc_androidbeta_steps_download1(inputs)
	if (locale === "bg") return bg_misc_androidbeta_steps_download1(inputs)
	if (locale === "ru") return ru_misc_androidbeta_steps_download1(inputs)
	if (locale === "uk") return uk_misc_androidbeta_steps_download1(inputs)
	if (locale === "ar") return ar_misc_androidbeta_steps_download1(inputs)
	if (locale === "hi") return hi_misc_androidbeta_steps_download1(inputs)
	if (locale === "th") return th_misc_androidbeta_steps_download1(inputs)
	if (locale === "ja") return ja_misc_androidbeta_steps_download1(inputs)
	if (locale === "zh-CN") return zh_cn2_misc_androidbeta_steps_download1(inputs)
	if (locale === "zh-Hant") return zh_hant1_misc_androidbeta_steps_download1(inputs)
	return ko_misc_androidbeta_steps_download1(inputs)
});
export { misc_androidbeta_steps_download1 as "misc.androidBeta.steps.download" }